import styled from "styled-components";
import { Black, Dark, Gray5, WerfenColor } from "../../../../Constants/ColorChart";
import { Th } from "react-super-responsive-table";

export const Title = styled.h2`
  color: ${ WerfenColor }
  font-size: 30px;
  margin-top: 0;
  margin-bottom: 1%;
  @media (max-width: 992px){
    font-size: 18px;
  }
`;

export const HeaderTitle = styled.p`
    ${ props => props.tabletFormat && `margin-bottom: 0; font-size: 12px` }
    margin-left:0.1vw
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;

  @media screen and (min-width: 992px){
    font-size: 20px;
  }
`;

export const TableHeader = styled.th`
  text-align: left;
  color: ${ Dark };
  text-transform: uppercase;
  font-weight: 200;
  font-size: 14px;
  letter-spacing: 2px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 10px;

  @media screen and (min-width: 1200px){
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
   // max-width: 20px;
  }
`;

export const DateWrapper = styled.div`
    display: flex;
    ${ props => props.tabletFormat ? "padding-right: 8px; width: 10vw " : props.mobileFormat ? "padding-right: 8px; width: 11vw ":"padding-right: 0; width: auto;" }
`;
export const WrapperDiv = styled.div`
    width: 100%;
    ${ props => props.centered ? "margin-left: auto; margin-right: auto; width: 90%;" : "width: 100%;" }
    margin-bottom:3%;
    color: ${ Black }; 
    padding: 2%;
    ${ props => !props.withoutShadows && `border: 2px solid ${ Gray5 }; background-clip: padding-box;` }
`;
